/* eslint-disable */
// @ts-nocheck

import $ from 'jquery';
import prestashop from 'prestashop';
import moment, { Moment } from 'moment';
import 'moment-timezone';
import { DateRangePicker } from '@/plugins/vanilla-daterange-picker';
import { createComponent } from '@/helpers/alpine';
import {
    TDateRangePickerLocale,
    TDateRangePickerOptions,
    TDateRangePicker,
} from '~types/vanilla-daterange-picker';

type Ranges = Record<string, string>;
type ParsedRanges = Record<string, [moment.Moment, moment.Moment]>;

interface AjaxDateLocationData {
    year: number | string;
    month?: number | string;
    slot?: string;
    currentDate?: string;
    action: string;
    ajax: number;
}

const DaterangePicker = createComponent(() => ({
    dateRangePicker: null as TDateRangePicker | null,
    dateRangeSelected: false as string | boolean,
    monthChangeInProgress: false,

    init() {
        if (prestashop.shop['is_location']) {
            this.initDateRangePicker(prestashop.shop.currentRanges);

            const input = document.querySelector(
                '.js-change-date',
            ) as HTMLElement;

            input.addEventListener('click', (e) => {
                const picker = document.querySelector<HTMLInputElement>(
                    '.js-location-daterangepicker',
                );
                if (picker) picker.click();
            });

            const select = document.querySelector(
                'a[href="#select-date"]',
            ) as HTMLElement;

            if (select) {
                select.addEventListener('click', (e) => {
                    const dom = document.getElementById('select-date-js');
                    if (dom) {
                        window.scrollTo({
                            top: dom.offsetTop - dom.offsetHeight / 2,
                            behavior: 'smooth',
                        });
                        const input = document.querySelector<HTMLInputElement>(
                            '.js-location-daterangepicker',
                        );
                        if (input) input.click();
                    }
                    e.preventDefault();
                });
            }
        }
    },

    initDateRangePicker(ranges: Ranges) {
        const parsedRanges = this.parseRanges(ranges);

        if (!this.dateRangePicker) {
            const input = document.querySelector<HTMLInputElement>(
                '.js-location-daterangepicker',
            );
            if (!input) return;

            this.dateRangePicker = new DateRangePicker(input, {
                minDate: moment().tz('Europe/Paris'),
                autoUpdateInput: false,
                alwaysShowCalendars: true,
                showCustomRangeLabel: false,
                autoApply: true,
                drops: 'auto',
                opens: 'center',
                locale: {
                    format: 'DD/MM/YYYY',
                    separator: ' - ',
                    fromLabel: 'De',
                    toLabel: 'à',
                    weekLabel: 'W',
                    daysOfWeek: [
                        'di',
                        'lu',
                        'ma',
                        'me',
                        'je',
                        've',
                        'sa',
                    ],
                    monthNames: [
                        'Janvier',
                        'Février',
                        'Mars',
                        'Avril',
                        'Mai',
                        'Juin',
                        'Juillet',
                        'Aout',
                        'Septembre',
                        'Octobre',
                        'Novembre',
                        'Décembre',
                    ],
                    firstDay: 1,
                },
                ranges: parsedRanges,
            }) as DateRangePicker;

            if (this.dateRangePicker) {
                this.setupListeners();
            }
        } else {
            this.refreshRanges(this.dateRangePicker, parsedRanges);
        }
    },

    setupListeners() {
        const picker = this.dateRangePicker;

        const domContainer = Array.isArray(this.dateRangePicker.container)
            ? this.dateRangePicker.container[0]
            : this.dateRangePicker.container;

        domContainer.addEventListener('apply.daterangepicker', () => {
            this.setDateLocation(picker);
        });

        document.addEventListener('click', (evt) => {
            const t = evt.target as HTMLElement;
            const parent = t.parentNode as HTMLElement;
            if (
                (t &&
                    (t.classList.contains('next') ||
                        t.classList.contains('prev'))) ||
                (parent &&
                    (parent.classList.contains('next') ||
                        parent.classList.contains('prev')))
            ) {
                this.getRanges(picker.leftCalendar.month);
            }
        });

        if (prestashop.shop.selectedSlot) {
            this.dateRangePicker.setStartDate(
                moment.unix(prestashop.shop.selectedSlot[0]),
                this.dateRangePicker.locale.format,
            );
            this.dateRangePicker.setEndDate(
                moment.unix(prestashop.shop.selectedSlot[1]),
                this.dateRangePicker.locale.format,
            );
        }

        // Désactive la sélection custom sur ancienne navigation
        const calendar = domContainer.querySelector('.drp-calendar');
        if (calendar) {
            calendar.removeEventListener('mousedown', () => {});
        }

        domContainer.addEventListener('mouseover', (evt) => {
            const t = evt.target as HTMLElement;

            if (t && t.matches('.ranges li')) {
                if (this.monthChangeInProgress) return false;
                const label = t.getAttribute('data-range-key');
                if (
                    !label ||
                    typeof this.dateRangePicker?.ranges[label] === 'undefined'
                )
                    return false;

                const startMonth = this.dateRangePicker.leftCalendar.month;
                const dates = this.dateRangePicker.ranges[label];
                this.dateRangePicker.startDate = dates[0];
                this.dateRangePicker.endDate = dates[1];
                this.dateRangePicker.updateView();

                if (this.dateRangePicker.leftCalendar.month !== startMonth) {
                    this.monthChangeInProgress = true;
                    this.getRanges(this.dateRangePicker.leftCalendar.month);
                    this.dateRangePicker.startDate = dates[0];
                    this.dateRangePicker.endDate = dates[1];
                    this.dateRangePicker.updateView();
                    this.dateRangeSelected = label;
                }
            }
        });
    },

    async ajaxDateLocation(
        data: AjaxDateLocationData,
        callback: (data: AjaxDateLocationData) => void,
    ) {
        try {
            const response = await fetch(prestashop.urls.pages.index, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type':
                        'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: new URLSearchParams(data as Record<string, string>),
            });

            const contentType = response.headers.get('content-type') || '';

            let result: any;

            if (contentType.includes('application/json')) {
                result = await response.json();

                if (!response.ok) {
                    result.error = true;
                    result.errorMsg = `Erreur HTTP ${response.status}`;
                }

                callback(result);
            }
        } catch (error) {
            callback({
                error: true,
                errorMsg: 'Error JSON',
            });
        }
    },

    getRanges(startDate: Moment = moment()) {
        this.ajaxDateLocation(
            {
                year: moment().year(),
                currentDate: startDate.format('YYYY-MM-01'),
                action: 'dateRangeLocation',
                ajax: 1,
            },
            (data) => {
                if (!data.error) {
                    this.initDateRangePicker(data.ranges);
                    setTimeout(() => {
                        this.monthChangeInProgress = false;
                    }, 1000);
                } else {
                    console.warn(
                        'Erreur getRanges:',
                        data.errorMsg,
                        data.raw || '',
                    );
                }
            },
        );
    },

    parseRanges(ranges: Ranges): ParsedRanges {
        const obj: ParsedRanges = {};

        if (!ranges) return obj;

        for (const range in ranges) {
            if (Object.hasOwnProperty.call(ranges, range)) {
                const label = ranges[range];
                const startEnd = JSON.parse(range);
                obj[label] = [
                    moment(startEnd[0] * 1000).tz('Europe/Paris'),
                    moment(startEnd[1] * 1000).tz('Europe/Paris'),
                ];
            }
        }

        return obj;
    },

    refreshRanges(picker: TDaterangepicker, ranges: ParsedRanges) {
        let start: moment.Moment, end: moment.Moment;

        picker.ranges = {};

        for (const range in ranges) {
            if (typeof ranges[range][0] === 'string')
                start = moment(ranges[range][0], picker.locale.format).tz(
                    'Europe/Paris',
                );
            else start = moment(ranges[range][0]).tz('Europe/Paris');

            if (typeof ranges[range][1] === 'string')
                end = moment(ranges[range][1], picker.locale.format).tz(
                    'Europe/Paris',
                );
            else end = moment(ranges[range][1]).tz('Europe/Paris');

            picker.ranges[range] = [start, end];
        }

        let list = '<ul>';

        for (const range in picker.ranges) {
            if (this.dateRangeSelected && this.dateRangeSelected === range) {
                list += `<li data-range-key="${range}" class="active">${range}</li>`;
                this.dateRangeSelected = false;
            } else {
                list += `<li data-range-key="${range}">${range}</li>`;
            }
        }
        const domContainer = Array.isArray(this.dateRangePicker.container)
            ? this.dateRangePicker.container[0]
            : this.dateRangePicker.container;

        domContainer.querySelector('.ranges')!.innerHTML = list;
        const rangesContainer = domContainer.querySelector('.ranges');
        if (rangesContainer) {
            rangesContainer.innerHTML = list;
        }

        // Ré-attacher le listener de clic sur les ranges après la mise à jour du DOM
        if (picker.reattachRangeClickListener) {
            picker.reattachRangeClickListener();
        }
    },

    refreshInputsWithDateRangePicker(picker: TDateRangePicker) {
        const inputHome = document.querySelector('.js-full-date');
        const start =
            picker.startDate.format('D') +
            ' ' +
            picker.locale.monthNames[picker.startDate.month()];
        const end =
            picker.endDate.format('D') +
            ' ' +
            picker.locale.monthNames[picker.endDate.month()];
        if (inputHome) {
            inputHome.classList.add('date-filled');
            inputHome.innerHTML = start + ' - ' + end;
        } else {
            const startEl = document.querySelector('.js-start-date');
            const endEl = document.querySelector('.js-end-date');
            if (startEl) startEl.textContent = start;
            if (endEl) endEl.textContent = end;
        }
    },

    setDateLocation(picker: TDateRangePicker) {
        const year = picker.startDate.format('YYYY');
        const month = picker.startDate.format('MM');
        const slot = JSON.stringify([
            picker.startDate.unix(),
            picker.endDate.unix(),
        ]);

        this.ajaxDateLocation(
            {
                year,
                month,
                slot,
                action: 'dateLocation',
                ajax: 1,
            },
            (data) => {
                if (data.error != false) {
                    alert(data.errorMsg);
                    return;
                }

                if (data.refresh) {
                    if (
                        prestashop.page.page_name === 'product' ||
                        prestashop.page.page_name === 'cart'
                    ) {
                        window.location.reload();
                    } else {
                        if (prestashop.page.page_name !== 'index') {
                            let url = window.location.href.replace(
                                window.location.hash,
                                '',
                            );
                            url +=
                                url.indexOf('?') > 0
                                    ? '&from-xhr'
                                    : '?from-xhr';

                            fetch(url, {
                                headers: {
                                    Accept: 'application/json',
                                },
                            })
                                .then((res) => {
                                    const contentType =
                                        res.headers.get('content-type') || '';
                                    if (
                                        !contentType.includes(
                                            'application/json',
                                        )
                                    ) {
                                        throw new Error(
                                            `Réponse non JSON: ${contentType}`,
                                        );
                                    }
                                    return res.json();
                                })
                                .then((data) => {
                                    prestashop.emit(
                                        'updateProductListDom',
                                        data,
                                    );
                                    this.updateProductListDOM(data);
                                })
                                .catch((error) => {
                                    console.error('Error:', error);
                                });
                        }

                        this.refreshInputsWithDateRangePicker(picker);
                    }
                }
            },
        );
    },

    updateProductListDOM(data) {
        const btnPrev = document.querySelector(
            'js-pagination-btn-prev',
        ) as HTMLButtonElement;
        const btnNext = document.querySelector(
            'js-pagination-btn-next',
        ) as HTMLButtonElement;

        if ('products' in data) {
            const parser = new DOMParser();
            const renderedProducts = parser.parseFromString(
                data.rendered_products,
                'text/html',
            );
            const newProducts = renderedProducts.querySelectorAll(
                '.js-product',
            ) as NodeListOf<HTMLElement>;
            const productsList = document.querySelector('.js-products-list');

            if (productsList) {
                const childs = productsList.querySelectorAll(
                    '.js-product',
                ) as NodeListOf<HTMLElement>;

                childs.forEach((product) => product.remove());
                newProducts.forEach((product) => {
                    productsList.appendChild(product);
                });
            }

            history.pushState({}, '', data.current_url);
        }

        if (
            btnNext &&
            'pagination' in data &&
            data.pagination.current_page < data.pagination.pages_count
        ) {
            btnNext.value = btnNext.value.replace(
                /([?&]page=)(\d+)/,
                (_, p1) => `${p1}${data.pagination.current_page + 1}`,
            );
        } else if (btnNext) {
            btnNext.remove();
        }

        if (
            btnPrev &&
            'pagination' in data &&
            data.pagination.current_page < data.pagination.pages_count
        ) {
            btnPrev.value = btnPrev.value.replace(
                /([?&]page=)(\d+)/,
                (_, p1) => `${p1}${data.pagination.current_page + 1}`,
            );
        } else if (btnPrev) {
            btnPrev.remove();
        }
    },
}));

export { DaterangePicker };
